import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Typography } from '@klp/design';
import { NumberFormatted } from '@klp/formgenerator/components/NumberFormatted';

const useStyles = makeStyles(() => ({
    numberCell: {
        textAlign: 'right',
    },
}));

type ProsjektAvfallSummaryRowProps = {
    id: string;
    rowTitle: string;
    mengde: number;
    totalMengde: number;
    isEditMode: boolean;
};

export function ProsjektAvfallSummaryRow({
    id,
    rowTitle,
    mengde,
    totalMengde,
    isEditMode,
}: ProsjektAvfallSummaryRowProps) {
    const classes = useStyles();
    const kg = ' kg';

    return (
        <Grid key={id} container={true} spacing={1}>
            <Grid item={true} xs={isEditMode ? 7 : 8}>
                <Typography>{rowTitle}</Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography>
                    <NumberFormatted value={mengde} suffix={kg} />
                </Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography>
                    <NumberFormatted
                        value={(mengde / totalMengde) * 100}
                        decimalScale={1}
                        suffix=" %"
                    />
                </Typography>
            </Grid>
        </Grid>
    );
}
